import { FormattedMessage } from 'react-intl';

import type { Project } from '@/lib/queries/project';
import type { AnyResource } from '@/lib/queries/resource';

import { Host } from './Host';
import { ResourceInstance } from './ResourceInstance';

interface ResourceProps {
  resource: AnyResource;
  mainProject: Project;
  resourceNodeId: string;
  from?: string;
  to?: string;
}

export const Resource = ({
  resource,
  mainProject,
  resourceNodeId,
  from,
  to,
}: ResourceProps): JSX.Element => {
  switch (resource.type) {
    case 'CLOUD_RESOURCE': {
      return (
        <ResourceInstance
          resource={resource}
          mainProject={mainProject}
          resourceNodeId={resourceNodeId}
          from={from}
          to={to}
        />
      );
    }
    case 'HOST': {
      return <Host resource={resource} />;
    }
    // TODO - Implement screens for all other resource types
    default: {
      return (
        <p>
          <FormattedMessage id="global.notAvailable" />
        </p>
      );
    }
  }
};
